import React, { useContext, useEffect, useState } from "react";
import AppSettings from "../../../../Settings/AppSettings";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import { AttributeContext } from "../AttributeContext";
import EditAttributeConstraint from "./EditAttributeConstraint";
import Utils from "../../../../Common/Utils";
import Label from "../../../Common/components/Label";
import { DEFAULT_ATTRIBUTE_CONSTRAINT_VALUE, generateAttributeConstraintObject } from "../constants";

const AttributeConstraint = ({
  finalAttributeConstraint,
  setFinalAttributeConstraint,
  constraintModel,
  saveMessage = null,
}) => {
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const attributeContextDate = useContext(AttributeContext);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [collapse, setCollapse] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);

  const [attributeConstraint, setAttributeConstraint] = useState(null);

  useEffect(() => {
    setLoading({
      status: "",
      message: "",
    });
  }, [attributeContextDate.editingItem.id]);

  useEffect(() => {
    if (collapse && attributeConstraint === null) {
      fetchAttributes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapse]);

  useEffect(() => {
    if (collapse) {
      fetchAttributes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapse]);

  useEffect(() => {
    if (attributeConstraint) {
      setFinalAttributeConstraint(attributeConstraint);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributeConstraint]);

  async function fetchAttributes() {
    setLoading({
      status: "Loading",
      message: "Loading Attribute Constraints",
    });
    if (constraintModel) {
      setLoading({ status: "Success", message: undefined });
      const constraints = generateAttributeConstraintObject(constraintModel)
      setAttributeConstraint(constraints);
      setFinalAttributeConstraint(constraints);
    } else {
      let res = await ServiceWrapper.doGet(
        `${api_base_url}attribute/${attributeContextDate.editingItem.id}/constraints/get`,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (!res.errorfound) {
        setLoading({ status: "Success", message: undefined });
        const constraints = generateAttributeConstraintObject(res.data.data)
        setAttributeConstraint(constraints);
        setFinalAttributeConstraint(constraints);
      } else {
        setLoading({ status: "Error", message: "Error while loading details" });
      }
    }
  }

  function handle_collapse() {
    setCollapse(!collapse);
  }

  // async function handle_save() {
  //   setLoading({ status: "Loading", message: "Saving Attribute Constraints" });
  //   let res = await ServiceWrapper.doPost(
  //     `${api_base_url}attribute/${attributeContextDate.editingItem.id}/constraints/edit`,
  //     attributeConstraint,
  //     null,
  //     AuthManager.getGmsToken()
  //   );

  //   if (!res.errorfound) {
  //     if (res.data.done) {
  //       setLoading({
  //         status: "Success",
  //         message: res.data.message,
  //       });
  //       fetchAttributes();
  //     } else {
  //       setEnableEdit(false);
  //       setLoading({
  //         status: "Error",
  //         message: res.data.message,
  //       });
  //     }
  //   } else {
  //     setEnableEdit(false);
  //     setLoading({
  //       status: "Error",
  //       message: "Error while saving, Please try after some time.",
  //     });
  //   }
  //   setEnableEdit(false);
  //   setTimeout(() => {
  //     if (loading.status !== "Success")
  //       setLoading({
  //         status: "",
  //         message: "",
  //       });
  //   }, 5000);
  // }

  // function handle_cancel() {
  //     setAbsDetailsCopy(absDetails)
  //     setCollapse(true)
  // }

  return (
    <>
      <div className="accordion" id="accordionFlushConstraint">
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseConstraint"
            aria-expanded="false"
            aria-controls="flush-collapseConstraint"
            style={Utils.borderStyle()}
          >
            <div>
              <Label
                message={`${enableEdit ? "Update " : ""} Attribute Constraints`}
              />
            </div>
          </div>

          <div
            id="flush-collapseConstraint"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingConstraint"
            data-bs-parent="#accordionFlushConstraint"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
              <LoadingSuccessErrorAlert loading={loading} />

              {loading.status === "Success" && (
                <>
                  {/* {enableEdit ? (
                    <div
                      className="p-3"
                      style={{ border: "1px solid #d6d8d9" }}
                    >
                      <EditAttributeConstraint
                        attributeConstraint={attributeConstraint}
                        setAttributeConstraint={setAttributeConstraint}
                      />
                    </div>
                  ) : (


                  )} */}
                  <div>
                    <EditAttributeConstraint
                      attributeConstraint={attributeConstraint}
                      setAttributeConstraint={setAttributeConstraint}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttributeConstraint;

function LoadingSuccessErrorAlert({ loading }) {
  return (
    <>
      {loading.status === "Saving" && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Loading" && (
        <div className="aalert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Error" && (
        <div className="alert alert-danger bg-white small p-2" role="alert">
          <span className="fas fa-exclamation-triangle" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Success" && loading.message !== undefined && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="far fa-check-circle" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
    </>
  );
}
